var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:table",
    clipPath: "url(#clip0_7644_176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.125 1H10.875C11.2065 1 11.5245 1.1317 11.7589 1.36612C11.9933 1.60054 12.125 1.91848 12.125 2.25V9.75C12.125 10.0815 11.9933 10.3995 11.7589 10.6339C11.5245 10.8683 11.2065 11 10.875 11H2.125C1.79348 11 1.47554 10.8683 1.24112 10.6339C1.0067 10.3995 0.875 10.0815 0.875 9.75V2.25C0.875 1.91848 1.0067 1.60054 1.24112 1.36612C1.47554 1.1317 1.79348 1 2.125 1ZM2.125 3.5V6H5.875V3.5H2.125ZM7.125 3.5V6H10.875V3.5H7.125ZM2.125 7.25V9.75H5.875V7.25H2.125ZM7.125 7.25V9.75H10.875V7.25H7.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7644_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.1f3bc8b82a3ebdc97dce56de363e5a57.svg";
export { ForwardRef as ReactComponent };